
import { useEffect } from 'react';

export const useCanonicalUrl = (url: string) => {
  useEffect(() => {
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    
    link.setAttribute('href', url);

    return () => {
      // Optional: Clean up by removing the link when the component unmounts
      // but in a SPA, you might want to leave it or update it instead.
    };
  }, [url]);
};
